import { Component, Injectable, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { lastValueFrom } from "rxjs";
import { BaseDialogService, NonNullableConfigData, TilbyDialogContentComponent, TilbyDialogProgressBarComponent, TilbyDialogToolbarComponent } from "@tilby/tilby-ui-lib/components/tilby-dialog";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { restManager } from "app/ajs-upgraded-providers";
import { AlertDialogService } from "../alert-dialog";

type EInvoiceCredentialsDialogData = {}

@Component({
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        TilbyDialogContentComponent,
        TilbyDialogToolbarComponent,
        TilbyDialogProgressBarComponent,
        TranslateModule,
        ReactiveFormsModule
    ],
    selector: 'e-invoice-credentials-dialog',
    templateUrl: './e-invoice-credentials-dialog.component.html',
    styleUrls: ['./e-invoice-credentials-dialog.component.scss']
})
export class EInvoiceCredentialsDialogComponent {
    protected readonly data: EInvoiceCredentialsDialogData = inject(MAT_DIALOG_DATA);
    private readonly alertDialogService = inject(AlertDialogService);
    private readonly translateService = inject(TranslateService);
    protected readonly restManager = inject(restManager);
    private readonly matDialogRef = inject(MatDialogRef);
    private readonly formBuilder = inject(FormBuilder);

    protected isWorking: boolean = false;
    protected digitalHubCredentials = this.formBuilder.group({
        userName: ['', [Validators.required]],
        password: ['', [Validators.required]]
    });

    /**
     * Confirms the credentials inserted by the user
     * @protected
     */
    protected async confirm() {
        if(this.digitalHubCredentials.invalid) {
            return;
        }

        let reqBody = [
            {
                id: 'backend.settings.dailyclosing.digital_username',
                value: this.digitalHubCredentials.controls.userName.value
            }, {
                id: 'backend.settings.dailyclosing.digital_hub_password',
                value: this.digitalHubCredentials.controls.password.value
            }
        ];

        this.isWorking = true;

        try {
            const response = await this.restManager.post('settings_corrispettivi', reqBody);

            if(response) {
                this.matDialogRef.close();
            }
        } catch(error: any) {
            const errMsg = this.translateService.instant('SETTINGS.SETTINGS.DIGITAL_HUB_OWNED.ERRORS.CONNECTION_ERROR');

            this.alertDialogService.openDialog({ data: { messageLabel: errMsg } });
        } finally{
            this.isWorking = false;
        };
    };
}

@Injectable({
    providedIn: "root",
})
export class EInvoiceCredentialsDialogService extends BaseDialogService {
    private readonly dialogRef = inject(MatDialog);

    public openDialog(config?: NonNullableConfigData<EInvoiceCredentialsDialogData>) {
        const data: EInvoiceCredentialsDialogData = config?.data||{};
        const configEdited: NonNullableConfigData<EInvoiceCredentialsDialogData> = {
            ...config,
            ...this.switchMobileDesktopDimensions(),
            disableClose: true,
            data,
        };
        return lastValueFrom(
            this.dialogRef.open(EInvoiceCredentialsDialogComponent, configEdited).afterClosed()
        );
    }
}
